import { Field } from '../../../../../components';

export const fields: Field[] = [
  { label: 'Stakeholder Group', key: 'name', isRequired: true },
  { label: 'Contact First Name', key: 'contactFirstName' },
  { label: 'Contact Last Name', key: 'contactLastName' },
  { label: 'Email', key: 'email' },
  { label: 'Phone', key: 'phone', type: 'Phone' },
];
